import { render } from "./PostAds.vue?vue&type=template&id=266fdb19&scoped=true"
import script from "./PostAds.vue?vue&type=script&lang=js"
export * from "./PostAds.vue?vue&type=script&lang=js"

import "./PostAds.vue?vue&type=style&index=0&id=266fdb19&scoped=true&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266fdb19"]])

export default __exports__